<div class="px-3">
  <div class="row">
    <div class="col">
      <app-validated-checkbox-group
        [groupLabel]="'general.roles'"
        [items]="rolesItems"
        [formArray]="rolesArray"
        inputFormControlName="roles"
        controlNamePrefix="role"
        [leaveSpaceForValidation]="true"
        [requireAtLeastOne]="true"
        [validationTrainslations]="{
          requiredAtLeastOne:
            'admin.users.validation.atLeastOneRoleRequired' | translate
        }"
      />

      <hr class="pe-divider" />
    </div>
  </div>

  <app-profile-edit [formGroup]="personalFormGroup"></app-profile-edit>

  <hr class="pe-divider" />

  <div class="col-md-3">
    <app-validated-input
      [label]="'general.phone'"
      inputFormControlName="phoneNumber"
      [inputFormControl]="formGroup.controls.phoneNumber!"
      [leaveSpaceForValidation]="true"
      [validationTrainslations]="{
        pattern: ('admin.validation.phoneInvalid' | translate)
      }"
    ></app-validated-input>
  </div>

  <app-validated-dropdown
    [label]="'general.defaultLanguage'"
    inputFormControlName="defaultLanguageCode"
    [inputFormControl]="formGroup.controls.defaultLanguageCode"
    [haveEmptyOption]="true"
    [leaveSpaceForValidation]="true"
    [loading]="!genericStore.allLoaded()"
    [optionsStamp]="genericStore.languageEntities().length"
  >
    @for (l of genericStore.languageEntities(); track l.code) {
    <option [ngValue]="l.code">{{ l.code }}</option>
    }
  </app-validated-dropdown>
</div>
